export const addWeekSeconds = (date: number) => date + 604800;
export const subtractWeekSeconds = (date: number) => date - 604800;
